/**
 * Language translations for the app
 */
export const translations = {
  en: {
    welcome: "Welcome back!",
    manageTokens: "Manage your utility tokens",
    totalSpent: "Total Spent",
    tokensPurchased: "Tokens Purchased",
    savedMeters: "Saved Meters",
    electricity: "Electricity",
    water: "Water",
    recentTransactions: "Recent Transactions",
    noTransactions: "No transactions yet",
    buyFirstToken: "Buy your first token",
    viewAll: "View all",
    home: "Home",
    buyToken: "Pay Bill",
    meters: "Meters",
    subscriptions: "Subscriptions",
    history: "History",
    accounts: "Accounts",
    profile: "Profile",
    logout: "Logout",
    admin: "Admin",
    selectProvider: "Select Provider",
    enterMeterNumber: "Enter meter number",
    enterAmount: "Enter amount",
    payNow: "Pay Now",
    processing: "Processing...",
    transactionHistory: "Transaction History",
    allTransactions: "All your transactions",
    status: "Status",
    amount: "Amount",
    date: "Date",
    provider: "Provider",
    meterNumber: "Meter Number",
    pending: "Pending",
    success: "Success",
    failed: "Failed",
    profile: "Profile",
    personalInfo: "Personal Information",
    fullName: "Full Name",
    phone: "Phone",
    email: "Email",
    saveChanges: "Save Changes",
    changePIN: "Change PIN",
    currentPIN: "Current PIN",
    newPIN: "New PIN",
    confirmPIN: "Confirm PIN",
    updatePIN: "Update PIN",
    deleteAccount: "Delete Account",
    deleteWarning: "This action cannot be undone.",
    cancel: "Cancel",
    confirm: "Confirm",
    dstv: "DStv",
    gotv: "GOtv",
    enterSmartCard: "Enter Smart Card Number",
    enterIUC: "Enter IUC Number",
    selectPackage: "Select Package",
    renew: "Renew",
    subscribe: "Subscribe",
    expiresIn: "Expires in",
    days: "days",
    accountNumber: "Account Number",
    token: "Token",
    units: "Units",
    reference: "Reference",
    downloadReceipt: "Download Receipt",
    notifications: "Notifications",
    markAllRead: "Mark all read",
    noNotifications: "No notifications",
    settings: "Settings",
    theme: "Theme",
    language: "Language",
    biometrics: "Biometrics",
    enableBiometrics: "Enable biometrics login",
    adminDashboard: "Admin Dashboard",
    users: "Users",
    transactions: "Transactions",
    revenue: "Revenue",
    analytics: "Analytics",
  },
  ny: {
    welcome: "Takulandirani!",
    manageTokens: "Yanganirani ma tokeni anu",
    totalSpent: "Zonse Zomwe Mwagwiritsa",
    tokensPurchased: "Ma Tokeni Omwe Mwagula",
    savedMeters: "Ma Mita Osungidwa",
    electricity: "Magetsi",
    water: "Madzi",
    recentTransactions: "Zomwe Zachitika Posachedwa",
    noTransactions: "Palibe zomwe zachitika",
    buyFirstToken: "Gulani tokeni yanu yoyamba",
    viewAll: "Onani zonse",
    home: "Kunyumba",
    buyToken: "Lipirani Bilu",
    meters: "Ma Mita",
    subscriptions: "Ma Subscription",
    history: "Mbiri",
    accounts: "Ma Akaunti",
    profile: "Mbiri Yanu",
    logout: "Tulukani",
    admin: "Woyang'anira",
    selectProvider: "Sankhani Othandizira",
    enterMeterNumber: "Lembani nambala ya mita",
    enterAmount: "Lembani ndalama",
    payNow: "Lipilani Tsopano",
    processing: "Ikugwira ntchito...",
    transactionHistory: "Mbiri ya Zomwe Zachitika",
    allTransactions: "Zonse zomwe zachitika",
    status: "Momwe zilili",
    amount: "Ndalama",
    date: "Tsiku",
    provider: "Othandizira",
    meterNumber: "Nambala ya Mita",
    pending: "Ikudikira",
    success: "Yapambana",
    failed: "Yalephereka",
    profile: "Mbiri Yanu",
    personalInfo: "Zambiri Zanu",
    fullName: "Dzina Lanu Lonse",
    phone: "Foni",
    email: "Imelo",
    saveChanges: "Sungani Zosintha",
    changePIN: "Sinthani PIN",
    currentPIN: "PIN Yamakono",
    newPIN: "PIN Yatsopano",
    confirmPIN: "Tsimikizani PIN",
    updatePIN: "Sinthani PIN",
    deleteAccount: "Chotsani Akaunti",
    deleteWarning: "Izi sizitha kubwezeretsa.",
    cancel: "Lekani",
    confirm: "Vomerezani",
    dstv: "DStv",
    gotv: "GOtv",
    enterSmartCard: "Lembani Nambala ya Smart Card",
    enterIUC: "Lembani Nambala ya IUC",
    selectPackage: "Sankhani Phukusi",
    renew: "Bwezeretsan",
    subscribe: "Lowani",
    expiresIn: "Ikutha mu",
    days: "masiku",
    accountNumber: "Nambala ya Akaunti",
    token: "Tokeni",
    units: "Ma Units",
    reference: "Reference",
    downloadReceipt: "Tsitsani Risiti",
    notifications: "Zidziwitso",
    markAllRead: "Werengani zonse",
    noNotifications: "Palibe zidziwitso",
    settings: "Zosintha",
    theme: "Mtundu",
    language: "Chilankhulo",
    biometrics: "Biometrics",
    enableBiometrics: "Yatsani biometrics",
    adminDashboard: "Admin Dashboard",
    users: "Ogwiritsa",
    transactions: "Zomwe zachitika",
    revenue: "Ndalama",
    analytics: "Analytics",
  },
  de: {
    welcome: "Willkommen zurück!",
    manageTokens: "Verwalten Sie Ihre Utility-Token",
    totalSpent: "Gesamtausgaben",
    tokensPurchased: "Gekaufte Token",
    savedMeters: "Gespeicherte Zähler",
    electricity: "Strom",
    water: "Wasser",
    recentTransactions: "Letzte Transaktionen",
    noTransactions: "Noch keine Transaktionen",
    buyFirstToken: "Kaufen Sie Ihren ersten Token",
    viewAll: "Alle anzeigen",
    home: "Startseite",
    buyToken: "Rechnung bezahlen",
    meters: "Zähler",
    subscriptions: "Abonnements",
    history: "Verlauf",
    accounts: "Konten",
    profile: "Profil",
    logout: "Abmelden",
    admin: "Admin",
    selectProvider: "Anbieter auswählen",
    enterMeterNumber: "Zählernummer eingeben",
    enterAmount: "Betrag eingeben",
    payNow: "Jetzt bezahlen",
    processing: "Wird verarbeitet...",
    transactionHistory: "Transaktionsverlauf",
    allTransactions: "Alle Ihre Transaktionen",
    status: "Status",
    amount: "Betrag",
    date: "Datum",
    provider: "Anbieter",
    meterNumber: "Zählernummer",
    pending: "Ausstehend",
    success: "Erfolgreich",
    failed: "Fehlgeschlagen",
    profile: "Profil",
    personalInfo: "Persönliche Informationen",
    fullName: "Vollständiger Name",
    phone: "Telefon",
    email: "E-Mail",
    saveChanges: "Änderungen speichern",
    changePIN: "PIN ändern",
    currentPIN: "Aktuelle PIN",
    newPIN: "Neue PIN",
    confirmPIN: "PIN bestätigen",
    updatePIN: "PIN aktualisieren",
    deleteAccount: "Konto löschen",
    deleteWarning: "Diese Aktion kann nicht rückgängig gemacht werden.",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    dstv: "DStv",
    gotv: "GOtv",
    enterSmartCard: "Smart Card Nummer eingeben",
    enterIUC: "IUC Nummer eingeben",
    selectPackage: "Paket auswählen",
    renew: "Erneuern",
    subscribe: "Abonnieren",
    expiresIn: "Läuft ab in",
    days: "Tagen",
    accountNumber: "Kontonummer",
    token: "Token",
    units: "Einheiten",
    reference: "Referenz",
    downloadReceipt: "Quittung herunterladen",
    notifications: "Benachrichtigungen",
    markAllRead: "Alle als gelesen markieren",
    noNotifications: "Keine Benachrichtigungen",
    settings: "Einstellungen",
    theme: "Thema",
    language: "Sprache",
    biometrics: "Biometrie",
    enableBiometrics: "Biometrie-Login aktivieren",
    adminDashboard: "Admin Dashboard",
    users: "Benutzer",
    transactions: "Transaktionen",
    revenue: "Umsatz",
    analytics: "Analysen",
  }
};

export default translations;
